const requestCatchError = (err) => ({
  status: err.response?.status,
  msg: err.response?.data?.message || 'Ocorreu um erro na sua solicitação',
  errors: err.response?.data?.errors || [],
});

export default requestCatchError;
